import React, { Component } from "react";
import { PropTypes } from "prop-types";
import {
  Button,
  Row,
  Col,
  ButtonToolbar,
  Table,
  FormControl,
  ControlLabel,
} from "react-bootstrap";
import { LoadingSpinner } from "../../../LoadingSpinner";
import { HandleDialog } from "../../../HandleDialog";
import { TitleRow } from "../../../TitleRow";
import DatePicker from "react-16-bootstrap-date-picker";
import { ViaPortoAPI } from "../../../../api/bussched/ViaPortoAPI";
import { LineAPI } from "../../../../api/datamanager/LineAPI";
import { ScheduleAPI } from "../../../../api/datamanager/ScheduleAPI";
import { DayTypeAPI } from "../../../../api/datamanager/DayTypeAPI";

export class ViaPortoScheduleGenerator extends Component {
  static contextTypes = {
    selectApp: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedScheduleType: "tabular",
      tabHasChanges: false,
      loading: true,
      dialog: {
        show: false,
        title: undefined,
        message: undefined,
        style: undefined,
        icon: undefined,
        argument: undefined,
      },
      lines: [],
      selectedLines: [],
      schedules: [],
      selectedSchedules: [],
      visibleSchedules: [],
      dayTypes: [],
      selectedDayTypes: [],
      referenceDate: new Date().toISOString(),
      schedulesToRender: [],
      headerAndFooter: {
        header1: "CA1",
        header2: "CA2",
        footer1: "RO1",
        footer2: "RO2",
      },
    };
  }

  componentDidMount() {
    this.context.selectApp("bussched", false);

    this.getLines();
  }

  getLines() {
    LineAPI.list()
      .then((response) => JSON.parse(response))
      .then((data) => {
        this.setState(
          {
            lines: data
          },
          () => {
            this.getSchedules();
          }
        );
      })
      .catch((err) => {
        this.setState({
          alertTitle: "Erro",
          alertMessage: err.message,
          alertStyle: "danger",
          icon: "remove",
          showErrorModal: true,
          errorLoading: true,
        });
      });
  }

  getSchedules() {
    var { lines } = this.state;
    let temp = [];

    lines.forEach(line => {
      ScheduleAPI.loadByLine(line.id)
      .then((response) => JSON.parse(response))
      .then((data) => {
        temp[line.id] = data;
      })
      .catch((err) => {
        this.setState({
          alertTitle: "Erro",
          alertMessage: err.message,
          alertStyle: "danger",
          icon: "remove",
          showErrorModal: true,
          errorLoading: true,
        });
      });
    });
    this.setState({
      schedules: temp,
      loading: false,
    },
    () => {
      this.getDayTypes();
    });
  }

  getDayTypes() {
    DayTypeAPI.list()
      .then((response) => JSON.parse(response))
      .then((data) => {
        this.setState({
          dayTypes: data,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          alertTitle: "Erro",
          alertMessage: err.message,
          alertStyle: "danger",
          icon: "remove",
          showErrorModal: true,
          errorLoading: true,
        });
      });
  }

  selectScheduleType = (selectedScheduleType) => {
    if (this.state.tabHasChanges) {
      // TODO show the dialog
      return;
    }
    this.setState({ selectedScheduleType });
  };

  checkIfActiveOnReferenceDate = (schedule, referenceDate) => {
    return (
      schedule.timeFrames.findIndex(
        (tf) =>
          referenceDate >= tf.startDate &&
          (null === tf.endDate || referenceDate <= tf.endDate)
      ) !== -1
    );
  };

  toggleLineSelection = (line) => {
    var {
      selectedLines,
      schedules,
      visibleSchedules,
      schedulesToRender,
      dayTypes,
    } = this.state;

    // Se a linha já estiver selecionada, remove
    if (selectedLines.filter((e) => e.id === line.id).length > 0) {
      var index = selectedLines.map((e) => e.id).indexOf(line.id);
      if (index > -1) {
        selectedLines.splice(index, 1);
      }
    }
    // caso contrário adiciona
    else {
      selectedLines.push(line);
    }

    // Seleciona os horários a mostrar
    let lineIds = selectedLines.map((e) => e.id);
    visibleSchedules = schedules.filter((value, index) => {
      return lineIds.includes(index);
    });
    visibleSchedules = [].concat.apply([], visibleSchedules);
    
    schedulesToRender = [];

    dayTypes.forEach((dayType) => {
      schedulesToRender.push(
        visibleSchedules
          .filter(
            (sched) =>
              sched.dayType !== undefined && sched.dayType.id === dayType.id
          )
          .sort((a, b) => a - b)
      );
    });

    schedulesToRender = schedulesToRender.filter(
      (schedList) => schedList.length > 0
    );

    this.setState(
      {
        selectedLines,
        visibleSchedules,
        schedulesToRender,
        dayTypes,
      },
      this.updateSelectedSchedules
    );
  };

  toggleScheduleSelection = (schedule) => {
    var { selectedSchedules, referenceDate } = this.state;

    // Não permite selecção se estiver fora da data de referência
    if (this.checkIfActiveOnReferenceDate(schedule, referenceDate) !== true) {
      return;
    }

    // Se o horário já estiver selecionado, remove
    if (selectedSchedules.filter((e) => e.id === schedule.id).length > 0) {
      var index = selectedSchedules.map((e) => e.id).indexOf(schedule.id);
      if (index > -1) {
        selectedSchedules.splice(index, 1);
      }
    }
    // caso contrário adiciona
    else {
      selectedSchedules.push(schedule);
    }

    this.setState({ selectedSchedules });
  };

  handleReferenceDateChange(e) {
    let { referenceDate } = this.state;

    let date = e !== null ? e : referenceDate;
    this.setState({ referenceDate: date }, this.updateSelectedSchedules);
  }

  updateSelectedSchedules = () => {
    var { selectedSchedules, selectedLines, referenceDate } = this.state;

    // Quando a data de referência ou as linhas selecionadas mudam, é preciso remover os horários selecionados que agora são inválidos
    // Remover os que estão inactivos na data de referência
    selectedSchedules = selectedSchedules.filter((schedule) =>
      this.checkIfActiveOnReferenceDate(schedule, referenceDate)
    );

    // Remover os que só estão associados com linhas que já não estão selecionadas
    let lineIds = selectedLines.map((e) => e.id);
    selectedSchedules = selectedSchedules.filter(
      (schedule) =>
        undefined !== schedule.line && lineIds.includes(schedule.line.id)
    );

    this.setState({ selectedSchedules });
  };

  storeValue = (param, value) => {
    var { headerAndFooter } = this.state;

    headerAndFooter[param] = value;

    this.setState({ headerAndFooter });
  };

  selectLinesTable = () => {
    const { lines, selectedLines } = this.state;

    let stringForTitle =
      selectedLines.length > 0
        ? selectedLines.length === 1
          ? ` (${selectedLines.length} linha selecionada)`
          : ` (${selectedLines.length} linhas selecionadas)`
        : "";

    return (
      <Row>
        <Col sm={12}>
          <TitleRow
            title={`Linhas${stringForTitle}`}
            showSeparator={false}
            showBackground={false}
            element="h2"
          />
          {undefined !== lines && lines.length !== 0 ? (
            <Table responsive striped hover>
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Código Externo</th>
                  <th>Nome de Ida</th>
                  <th>Nome de Volta</th>
                </tr>
              </thead>
              <tbody>
                {lines
                  .sort((a, b) => a.code.localeCompare(b.code))
                  .map((line, index) => (
                    <tr
                      key={`line-${index}`}
                      onClick={() => this.toggleLineSelection(line)}
                      className={`selectable  
                        ${
                          selectedLines.filter((e) => e.id === line.id).length >
                          0
                            ? "bus-sched-line-selected"
                            : null
                        }`}
                    >
                      <td>{line.code}</td>
                      <td>{line.extCode}</td>
                      <td>{line.goName}</td>
                      <td>{line.returnCode}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          ) : (
            <p className="empty-set">Não existem linhas disponíveis.</p>
          )}
        </Col>
      </Row>
    );
  };

  selectSchedulesTable = () => {
    const {
      selectedSchedules,
      dayTypes,
      schedulesToRender,
      referenceDate,
    } = this.state;

    let stringForTitle =
      selectedSchedules.length > 0
        ? selectedSchedules.length === 1
          ? ` (${selectedSchedules.length} horário selecionado)`
          : ` (${selectedSchedules.length} horários selecionados)`
        : "";

    return (
      <Row>
        <Col sm={12}>
          <TitleRow
            title={`Horários disponíveis${stringForTitle}`}
            showSeparator={false}
            showBackground={false}
            element="h2"
          >
            <ControlLabel className="padding-top-10">
              Data de Referência
            </ControlLabel>
            <DatePicker
              id="referenceDateDatePicker"
              dateFormat="DD/MM/YYYY"
              value={referenceDate}
              placeholder="Introduza a Data de Referência"
              onChange={(e) => this.handleReferenceDateChange(e)}
            />
          </TitleRow>
          {undefined !== schedulesToRender && schedulesToRender.length !== 0 ? (
            schedulesToRender.map((schedType, idx) => (
              <Row key={idx}>
                <Col sm={12}>
                  <TitleRow
                    title={dayTypes[idx].name}
                    showSeparator={false}
                    showBackground={true}
                    element="h2"
                  />
                </Col>
                <Col sm={12} className="table-small-screens">
                  <Table responsive>
                    <thead>
                      <tr>
                        <th className="width-70p">Nome</th>
                        <th className="width-30p">
                          Em Vigor na data de referência{" "}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {schedType.map((schedule, index) => (
                        <tr
                          key={`sched-${index}`}
                          className={`${
                            this.checkIfActiveOnReferenceDate(
                              schedule,
                              referenceDate
                            )
                              ? "selectable "
                              : ""
                          } ${
                            selectedSchedules.filter(
                              (e) => e.id === schedule.id
                            ).length > 0
                              ? "bus-sched-schedule-selected"
                              : null
                          }`}
                          onClick={() => this.toggleScheduleSelection(schedule)}
                        >
                          <td>
                            {schedule.name !== "undefined" ? schedule.name : ""}
                          </td>
                          <td colSpan={2}>
                            {this.checkIfActiveOnReferenceDate(
                              schedule,
                              referenceDate
                            )
                              ? "Sim"
                              : "Não"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            ))
          ) : (
            <p className="empty-set">Não existem horários disponíveis.</p>
          )}
        </Col>
      </Row>
    );
  };

  selectGenerationOptions = () => {
    return (
      <Row>
        <Col sm={12}>
          <TitleRow
            title={`Cabeçalho e rodapé`}
            showSeparator={false}
            showBackground={false}
            element="h2"
          />
        </Col>
        <Col sm={12} md={6}>
          <TitleRow
            title="Cabeçalho"
            showSeparator={false}
            showBackground={true}
            element="h2"
          />
          <FormControl
            type="text"
            value={this.state.header1}
            placeholder="Cabeçalho 1"
            onChange={(e) => this.storeValue("header1", e.target.value)}
          />
          <FormControl
            type="text"
            value={this.state.header2}
            placeholder="Cabeçalho 2"
            onChange={(e) => this.storeValue("header2", e.target.value)}
          />
        </Col>
        <Col sm={12} md={6}>
          <TitleRow
            title="Rodapé"
            showSeparator={false}
            showBackground={true}
            element="h2"
          />
          <FormControl
            type="text"
            value={this.state.footer1}
            placeholder="Rodapé 1"
            onChange={(e) => this.storeValue("footer1", e.target.value)}
          />
          <FormControl
            type="text"
            value={this.state.footer2}
            placeholder="Rodapé 2"
            onChange={(e) => this.storeValue("footer2", e.target.value)}
          />
        </Col>
      </Row>
    );
  };

  tabularModeScreens = () => {
    const { selectedLines, selectedSchedules } = this.state;

    let contents = [this.selectLinesTable()];

    if (selectedLines.length > 0) {
      contents.push([<hr />, this.selectSchedulesTable()]);
    }

    if (selectedSchedules.length > 0) {
      contents.push([<hr />, this.selectGenerationOptions()]);
    }

    return contents;
  };

  generateSchedules = () => {
    var { selectedScheduleType, selectedLines, selectedSchedules, selectedStops, referenceDate, headerAndFooter } = this.state;

    var selectedScheduleChar = "";

    if(selectedScheduleType === "tabular") {
      selectedScheduleChar = 'T';
    } else if(selectedScheduleType === "frequencies") {
      selectedScheduleChar = 'F';
    } else if(selectedScheduleType === "station") {
      selectedScheduleChar = 'S';
    }

    ViaPortoAPI.generate(selectedScheduleChar, selectedLines.map(a => a.id), selectedSchedules.map(a => a.id), referenceDate, selectedStops, headerAndFooter)
    .then(response => JSON.parse(response))
    .then(data => {
        this.setState({
            loading: false
        });
    })
    .catch(error => {
        this.setState({
            errorModal: {
                show: true,
                title: "Erro",
                message: error.message,
                style: "danger",
                icon: "remove"
           }
        });
    });
  }
  
  generate = () => {
    this.setState(
        {
            loading: true
        },
        this.generateSchedules
    );
  }

  render() {
    const {
      selectedScheduleType,
      dialog,
      selectedLines,
      selectedSchedules,
    } = this.state;
    let contents;

    if (selectedScheduleType === "tabular") {
      contents = this.tabularModeScreens();
    } else if (selectedScheduleType === "frequencies") {
      contents = this.tabularModeScreens();
    } else if (selectedScheduleType === "station") {
      contents = "";
    } else {
      contents = "";
    }

    return (
      <div>
        <TitleRow
          title="ViaPorto Custom Schedule Generator"
          showSeparator={true}
        >
          <Col className="padding-0">
            <ButtonToolbar className="pull-right">
              {selectedLines.length > 0 && selectedSchedules.length > 0 ? (
                <Button
                  bsStyle="success"
                  onClick={() => this.generate()}
                >
                  Gerar
                </Button>
              ) : null}
              <Button
                bsStyle={
                  this.state.selectedScheduleType === "tabular"
                    ? "primary"
                    : "default"
                }
                onClick={() => this.selectScheduleType("tabular")}
              >
                Tabular Web
              </Button>
              <Button
                bsStyle={
                  this.state.selectedScheduleType === "frequencies"
                    ? "primary"
                    : "default"
                }
                onClick={() => this.selectScheduleType("frequencies")}
              >
                Frequências Web
              </Button>
              <Button
                bsStyle={
                  this.state.selectedScheduleType === "station"
                    ? "primary"
                    : "default"
                }
                onClick={() => this.selectScheduleType("station")}
              >
                Por Estação
              </Button>
            </ButtonToolbar>
          </Col>
        </TitleRow>
        {this.state.loading ? <LoadingSpinner /> : contents}
        <HandleDialog
          show={dialog.show}
          title={dialog.title}
          message={dialog.message}
          style={dialog.style}
          icon={dialog.icon}
          argument={dialog.argument}
          onExit={(a, b) => this.onExit(a, b)}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/bussched/schedules/viaPorto/ViaPortoScheduleGenerator.js